<template>
  <div class="container-fluid">
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6"><h3 class="mb-0">{{ $t("MAIL_V2.MAIL_SETTINGS") }}</h3></div>
          <div class="col-6 text-right">
            <base-button class="elite-button add" icon size="sm" @click="save" :loading="saving">
              <span class="btn-inner--icon"><i class="fal fa-save"></i></span>
              <span class="btn-inner--text">{{ $t("COMMON.SAVE") }}</span>
            </base-button>
          </div>
        </div>
      </div>

      <div v-loading="loading">
        <div class="form-section">
          <h4><i class="fal fa-envelope"></i> {{ $t("MAIL_V2.SENDER_DEFAULTS") }}</h4>
          <div class="form-grid">
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.FROM_NAME')" v-model="form.from_name" /></div>
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.FROM_EMAIL')" v-model="form.from_email" /></div>
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.REPLY_TO_NAME')" v-model="form.reply_to_name" /></div>
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.REPLY_TO_EMAIL')" v-model="form.reply_to_email" /></div>
            <div class="form-grid-item">
              <base-input :label="$t('MAIL_V2.DEFAULT_LOCALE')">
                <el-select v-model="form.default_locale">
                  <el-option value="fr" label="Fran\u00e7ais" />
                  <el-option value="en" label="English" />
                </el-select>
              </base-input>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h4><i class="fal fa-palette"></i> {{ $t("MAIL_V2.BRANDING") }}</h4>
          <div class="form-grid">
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.LOGO_URL')" v-model="form.logo_url" /></div>
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.LOGO_HEIGHT')" v-model.number="form.logo_height" type="number" /></div>
            <div class="form-grid-item">
              <label>{{ $t("MAIL_V2.PRIMARY_COLOR") }}</label>
              <input type="color" v-model="form.brand_primary_color" class="color-input" />
            </div>
            <div class="form-grid-item">
              <label>{{ $t("MAIL_V2.SECONDARY_COLOR") }}</label>
              <input type="color" v-model="form.brand_secondary_color" class="color-input" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <h4><i class="fal fa-shoe-prints"></i> {{ $t("MAIL_V2.FOOTER") }}</h4>
          <div class="form-grid">
            <div class="form-grid-item form-grid-item--full">
              <base-input :label="$t('MAIL_V2.FOOTER_TEXT')">
                <textarea class="form-control" v-model="form.footer_text" rows="3"></textarea>
              </base-input>
            </div>
            <div class="form-grid-item"><base-input :label="$t('MAIL_V2.UNSUBSCRIBE_URL')" v-model="form.unsubscribe_url" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import BaseInput from "@/components/Inputs/BaseInput.vue";

export default {
  components: { BaseInput, [Select.name]: Select, [Option.name]: Option },

  data() {
    return {
      loading: false,
      saving: false,
      form: {
        default_locale: "fr",
        from_name: "",
        from_email: "",
        reply_to_name: "",
        reply_to_email: "",
        logo_url: "",
        logo_height: 40,
        brand_primary_color: "#576654",
        brand_secondary_color: "#EF8152",
        footer_text: "",
        unsubscribe_url: "",
      },
    };
  },

  computed: {
    ...mapGetters("organizations", { globalOrganization: "globalOrganization" }),
    ...mapGetters("profile", { me: "me" }),
    organizationId() { return this.globalOrganization?.id || this.me?.organization?.id; },
  },

  watch: {
    organizationId: {
      handler(val) { if (val) this.loadSettings(); },
      immediate: true,
    },
  },

  methods: {
    async loadSettings() {
      this.loading = true;
      try {
        const settings = await this.$store.dispatch("mailV2/getSettings", { orgId: this.organizationId });
        Object.keys(this.form).forEach((key) => {
          if (settings[key] !== undefined && settings[key] !== null) {
            this.form[key] = settings[key];
          }
        });
      } finally { this.loading = false; }
    },

    async save() {
      this.saving = true;
      try {
        await this.$store.dispatch("mailV2/updateSettings", { orgId: this.organizationId, data: this.form });
        this.$notify({ type: "success", message: this.$t("MAIL_V2.SETTINGS_SAVED") });
      } catch {
        this.$notify({ type: "danger", message: this.$t("ERRORS.SOMETHING_WENT_WRONG") });
      } finally { this.saving = false; }
    },
  },
};
</script>

<style scoped>
.form-section { margin-bottom: 20px; padding: 16px; border: 1px solid #e9ecef; border-radius: 8px; }
.form-section h4 { font-size: 14px; font-weight: 600; color: #495057; margin-bottom: 16px; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 20px; }
.form-grid-item--full { grid-column: 1 / -1; }
.color-input { width: 60px; height: 36px; border: 2px solid #dee2e6; border-radius: 6px; cursor: pointer; }
</style>
